import IconMore from '@bimser/icons/16/more';
import BCButton from '../../../BCButton';

import { Dropdown } from 'antd';
import classNames from 'classnames/bind';
import React from 'react';
import Styles from './assets/menuBoxStyles.scss';
import { IColumnButtonOptions } from './entities/IColumnButtonOptions';
import { dropdownWrapperTrigger } from './entities/Types';

const MenuBox = props => {
	const options: IColumnButtonOptions = props.data.column.editorOptions;
	const [open, setOpen] = React.useState<boolean>(false);

	const { column, data, text } = props.data;

	let items = options.getItems?.(props.data) || [];
	if (options.filterItems) {
		items = items.filter(item => options.filterItems(data, item));
	}

	const displayText = text || '\u00A0';
	if (!items.length) return displayText;

	return (
		<div className="row-sub-menu">
			<span title={displayText}>{displayText}</span>
			<div
				className={classNames({ ['row-sub-menu-dropdown']: true, open })}
				onClick={e => props.stopPropagation && e.stopPropagation()}
			>
				<Dropdown
					menu={{
						items: items,
						onClick: args => {
							setOpen(false);
							options.onClick({
								key: args.key,
								column,
								row: data
							});
						},
						rootClassName: Styles.dropdownMenu
					}}
					trigger={dropdownWrapperTrigger}
					placement="bottomRight"
					overlayClassName="row-sub-overlay-dropdown"
					destroyPopupOnHide
					onOpenChange={value => {
						setOpen(value);
					}}
				>
					<BCButton
						icon={<IconMore />}
						onClick={e => e.event.stopPropagation()}
						type="text"
					/>
				</Dropdown>
			</div>
		</div>
	);
};

export { MenuBox };
